import React from "react";
import PropTypes from "prop-types";
import wordIconUrl from "../../assets/icons/word-reference.svg";

/** Custom Word document icon for reference list rows. */
const WordReferenceIcon = ({ className }) => (
  <img src={wordIconUrl} className={className} width={18} height={17} alt="" aria-hidden />
);

WordReferenceIcon.propTypes = {
  className: PropTypes.string,
};

export default WordReferenceIcon;
